import axios from 'axios'
import { getAppEndpointVersion } from 'helpers'
import constants from '../constants'

export default function init() {
  console.log('moderation init')
}

export async function listRules(app, paginationPayload = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/rules?limit=50&${paginationPayload}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function listActivities(app, paginationPayload = '', startRange = '', endRange = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/blocked-messages?limit=50&${paginationPayload}&start=${startRange}&end=${endRange}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

// Generic helper for moderation GET endpoints using only Bearer auth now (apiKey removed)

export async function listFlaggedMessages(app, paginationPayload = '', startRange = '', endRange = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/flagged-messages?limit=50&${paginationPayload}&start=${startRange}&end=${endRange}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function listReviewedMessages(app, paginationPayload = '', startRange = '', endRange = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/reviewed-messages?limit=50&${paginationPayload}&start=${startRange}&end=${endRange}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

// Accept (mark as reviewed) a flagged message
export async function acceptFlaggedMessage(app, messageId) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/flagged-messages/${messageId}/accept`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.post(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${ccBearerToken}`,
          },
        },
      )
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

// Approve only (without reviewed flag) for flagged message
export async function approveFlaggedMessage(app, messageId) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/flagged-messages/${messageId}`
  const patchData = { status: 'approved' }
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.patch(URL, patchData, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

// Review (approve) flagged message using PATCH pattern (status + reviewed)
export async function reviewFlaggedMessage(app, messageId) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/flagged-messages/${messageId}`
  const patchData = { status: 'approved', reviewed: true }
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.patch(URL, patchData, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function blockFlaggedMessage(app, messageId) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/flagged-messages/${messageId}`
  const patchData = { status: 'disapproved' }
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.patch(URL, patchData, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function reviewFlaggedMessageFallback(
  app,
  messageId,
  body = { status: 'approved', reviewed: true },
) {
  const URL = `${constants.customerDomain}apps/${app.id}/flagged-messages/${messageId}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.patch(URL, body, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
          'Content-Type': 'application/json',
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false
}

// Ban sender of a flagged message (placeholder endpoint - adjust if actual differs)
export async function banSenderOfFlaggedMessage(app, messageId) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/flagged-messages/${messageId}/ban-sender`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.post(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${ccBearerToken}`,
          },
        },
      )
      return res.data
    }
  } catch (error) {
    return error.response?.data || false
  }
  return false
}

export async function getRule(id, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/rules/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function listRuleRevisions(id, app, pageNo = 1, searchText = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/rules/${id}/revisions?limit=5&page=${pageNo}&searchKey=${searchText}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function deleteRule(id, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/rules/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.delete(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function updateRule(id, post, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/rules/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.put(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function listKeywords(app, paginationPayload = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/keywords?limit=50&${paginationPayload}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function deleteKeyword(id, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/keywords/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.delete(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function addKeyword(post, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/keywords`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.post(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function updateKeyword(id, post, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/keywords/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.put(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function getKeyword(id, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/keywords/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function listConfiguration(app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/configuration`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function addRule(post, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/rules`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.post(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function addCustomCategory(post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/moderation/reasons`

  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getCustomCategories(app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/moderation/reasons`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function deleteCustomCategory(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/moderation/reasons/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function updateCustomCategory(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/moderation/reasons/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function updateBlockedMessageStatus(id, status, app, isReviewed = false) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/blocked-messages/${id}`
  const patchData = isReviewed ? { status, reviewed: true } : { status }
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.patch(URL, patchData, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function updateGlobalSettings(app, post) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/global-settings`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.put(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function getGlobalSettings(app) {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/global-settings`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function getFlaggedUsersOfMessage(app, id, paginationPayload = '') {
  const URL = `${constants.customerDomain}apps/${app.id}/moderation/${id}/flagged-users?limit=${
    constants.flaggedByUsersTableCount
  }${paginationPayload ? '&' : ''}${paginationPayload}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}
